import { authenticationConstants } from "../constants";

let jwtToken = JSON.parse(sessionStorage.getItem("jwtToken"));

const initialState = {
  regLoading: false,
  jwtLoading: false,
  refreshToken: null,
  jwtToken: jwtToken,
  refreshTokenError: "",
  jwtTokenError: "",
  registerInfo: {},
  regData: {},
  authData: {},
};
const authenticate = (state = initialState, action) => {
  switch (action.type) {
    case authenticationConstants.REGISTER_REQUEST:
      return {
        ...state,
        refreshToken: null,
        registerInfo: {},
        regLoading: true,
      };
    case authenticationConstants.REGISTER_SUCCESS:
      return {
        regLoading: false,
        refreshToken: action.response.data,
        registerInfo: action.response,
        jwtToken: null,
      };
    case authenticationConstants.REGISTER_FAILURE:
      return {
        ...state,
        regLoading: false,
        registerInfo: action.error,
      };
    case authenticationConstants.AUTHENTICATE_REQUEST:
      return {
        ...state,
        authData: {},
        jwtLoading: true,
      };
    case authenticationConstants.AUTHENTICATE_SUCCESS:
      return {
        ...state,
        jwtLoading: false,
        authData: action.response.data,
        jwtToken: action.response.data.jwtToken,
      };
    case authenticationConstants.AUTHENTICATE_FAILURE:
      return {
        ...state,
        authData: {},
        jwtLoading: false,
      };
    default:
      return state;
  }
};

export default authenticate;
